export { default } from "./RichMenu.vue";
